module.exports = __webpack_public_path__ + "img/gameart.d9939663.svg";